// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__LgmkH","footer":"ModalCreateQualiphyProcedure_footer__2N1kw","additionData":"ModalCreateQualiphyProcedure_additionData__1MSvc"};